<template>
  <div
    class="modal-card"
    style="width: auto"
  >
    <section class="modal-card-body">
      <div class="container">
        <div class="report-link">
          <a
            title="Budget &amp; Salary/Compensation Transparency Reporting"
            target="_blank"
            href="https://www.battlecreekpublicschools.org/about/data-and-reporting/transparency-reporting"
          >
            <span class="is-sr-only">Budget &amp; Salary/Compensation Transparency Reporting</span><img
              aria-hidden="true"
              src="/dist/assets/img/transparency-large.png"
              alt=""
            ></a>
          <h3>Budget &amp; Salary/Compensation Transparency Reporting</h3>
        </div>
        <div class="school-data">
          <a
            title="Michigan School Data Dashboard"
            target="_blank"
            href="https://www.mischooldata.org/dashboard?Common_Locations=1-D,912,70,0~2-A,0,0,0&Common_LocationIncludeComparison=False"
          >
            <span class="is-sr-only">Michigan School Data Dashboard</span><img
              aria-hidden="true"
              src="/dist/assets/img/mi-school-data.png"
              alt=""
            ></a>
          <h3>Michigan School Data Dashboard</h3>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {}
</script>
